import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=9ccaa9d6&scoped=true"
import script from "./integral.vue?vue&type=script&lang=ts"
export * from "./integral.vue?vue&type=script&lang=ts"
import style0 from "./integral.vue?vue&type=style&index=0&id=9ccaa9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccaa9d6",
  null
  
)

export default component.exports